import $ from 'jquery';
import 'slick-carousel';

$('.banner-slider__slider').each(function () {
    var $slider = $(this);

    $slider.slick({
        autoplay: false,
        infinite: true,
        arrows: true,
        dots: false,
        draggable: true,
        rows: 0,
        prevArrow: '<button title="'+ window.translationStrings.prevSlide +'" class="slick-prev fa-thin fa-arrow-left"></button>',
        nextArrow: '<button title="'+ window.translationStrings.nextSlide +'" class="slick-next fa-thin fa-arrow-right"></button>',
        appendArrows: $('<div>', {class: 'banner-slider__arrows'}).insertAfter($slider),
    });
});
